import React from "react";

function HandMonyIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17099 12.7893H5.67099C5.73926 12.787 5.80725 12.7991 5.87051 12.8249C5.93377 12.8507 5.99087 12.8895 6.03807 12.9389C6.08528 12.9883 6.12152 13.0471 6.14442 13.1114C6.16733 13.1758 6.17638 13.2442 6.17099 13.3123V22.7223C6.17656 22.7904 6.16762 22.8589 6.14476 22.9233C6.12191 22.9877 6.08565 23.0465 6.0384 23.0958C5.99115 23.1451 5.93396 23.1839 5.87063 23.2095C5.8073 23.2351 5.73925 23.247 5.67099 23.2443H3.17099"
        stroke="#10B77F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.322 10.584L8.39999 12.977C8.27376 13.1343 8.11503 13.2625 7.93467 13.3527C7.7543 13.443 7.55657 13.4932 7.35499 13.5H6.17099M6.17099 20.53C8.31499 22.155 10.271 23.246 11.534 23.246H17.807C18.567 23.246 19.045 23.192 19.375 22.201C19.879 19.671 20.228 17.113 20.421 14.541C20.421 14.019 19.898 13.496 18.853 13.496H12.921M10.554 12.205L9.00599 1.373C8.99497 1.29562 9.00069 1.21677 9.02276 1.14179C9.04484 1.06681 9.08275 0.997446 9.13395 0.938382C9.18514 0.879319 9.24842 0.831936 9.31951 0.799436C9.39059 0.766936 9.46783 0.750078 9.54599 0.75H17.1"
        stroke="#10B77F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.839 13.5011L12.923 4.3421C12.9155 4.27212 12.9229 4.20136 12.9447 4.13445C12.9664 4.06753 13.0021 4.00595 13.0493 3.95376C13.0965 3.90156 13.1542 3.85991 13.2186 3.83154C13.283 3.80316 13.3526 3.7887 13.423 3.7891H20.323C20.3957 3.78823 20.4676 3.80322 20.5339 3.83301C20.6002 3.86281 20.6592 3.9067 20.7068 3.96162C20.7544 4.01655 20.7895 4.08119 20.8095 4.15104C20.8296 4.2209 20.8342 4.29429 20.823 4.3661L19.443 13.5661"
        stroke="#10B77F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.696 9.37109C16.5965 9.37109 16.5011 9.33159 16.4308 9.26126C16.3605 9.19093 16.321 9.09555 16.321 8.99609C16.321 8.89664 16.3605 8.80125 16.4308 8.73093C16.5011 8.6606 16.5965 8.62109 16.696 8.62109M16.696 9.37109C16.7954 9.37109 16.8908 9.33159 16.9611 9.26126C17.0315 9.19093 17.071 9.09555 17.071 8.99609C17.071 8.89664 17.0315 8.80125 16.9611 8.73093C16.8908 8.6606 16.7954 8.62109 16.696 8.62109"
        stroke="#10B77F"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default HandMonyIcon;
